import { businessQuotesService } from '@/services/quotes/business';
import type { CopyInsuredObjectResponse } from '@/services/quotes/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCopyInsuredObject() {
  const queryClient = useQueryClient();

  return useMutation<
    { success: boolean; data?: CopyInsuredObjectResponse; error?: string },
    Error,
    { policyId: string; riskPk: number }
  >({
    mutationKey: ['quotes', 'business', 'copy-insured-object'],
    mutationFn: async ({ policyId, riskPk }) => {
      const response = await businessQuotesService.copyInsuredObject(
        policyId,
        riskPk
      );
      if (!response.success) throw new Error(response.error || 'Erro');
      return response;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['proposal-details', variables.policyId],
      });
    },
  });
}
